import {
  callAPI,
  makeAPICall,
  makeEncryptedAPICall,
  APICall,
} from "../../utils/ApiCall";
import config from "../../utils/config";
import { ToastContainer, toast } from "react-toastify";
import base64 from "base-64";
// import Cookies from 'universal-cookie';
import { setAccessToken, getAccessToken } from "../../utils/utilities";
import { json } from "react-router-dom";
import axios from "axios";

export const PROFILE_DATA = "PROFILE_DATA";
export const INIT_CALL = "INIT_CALL";
export const CONSENT_DATA = "CONSENT_DATA";
export const CONSENT_AUTHORIZED = "CONSENT_AUTHORIZED";
export const CONSENT_HISTORY = "CONSENT_HISTORY";
export const UPDATE_CONSENT = "UPDATE_CONSENT";

export const SAVE_AUTH_TOKEN = "SAVE_AUTH_TOKEN";
export const ENCRYPTAPISUCCCESS = "ENCRYPTAPISUCCCESS";
export const DECRYPTAPISUCCESS = "DECRYPTAPISUCCESS";
export const CREATCONSENTSUCCESS = "CREATCONSENTSUCCESS";
export const CALL_BACK_URL = "CALL_BACK_URL";
export const APP_NAME = "APP_NAME";
export const APP_LOGO = "APP_LOGO";
export const GET_CONSENT_TEXT = "GET_CONSENT_TEXT";
export const GET_CONSENTGROUPDATABY_GROUPID = "GET_CONSENTGROUPDATABY_GROUPID";
export const paramsFromState = "paramsFromState";
export const paramsFromStateHistory = "paramsFromStateHistory";

export const GET_TEMP_DETAILS = "GET_TEMP_DETAILS";
export const GET_PREFERENCE_CENTER_THEME = "GET_PREFERENCE_CENTER_THEME";

export const NEW_CODE = "NEW_CODE";
export const RECEIEVD_CLIENTID = "RECEIEVD_CLIENTID";
export const NEW_SUBSCRIPTIONKEY = "NEW_SUBSCRIPTIONKEY";
export const NEW_CALL_BACK_URL = "NEW_CALL_BACK_URL";
// export const UPDATE_CONSENT = "UPDATE_CONSENT"
// export const UPDATE_CONSENT = "UPDATE_CONSENT"
// export const UPDATE_CONSENT = "UPDATE_CONSENT"

function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

let today = new Date();
let start = today.toISOString();
let end = new Date(today.setFullYear(today.getFullYear() + 1)).toISOString();
// const cookies = new Cookies();

//new
let codetoken = config.CODE_TOKEN;
let encryptedData_Redirect_Portal = process.env.REACT_APP_REDIRECT_URL;

//let encryptedData_Redirect_Portal = `${process.env.REACT_REDIRECT_URL}`;
//alert(encryptedData_Redirect_Portal);

let encryptedData = "";

//new
export const save_code = (code) => ({
  type: NEW_CODE,
  payload: code,
});

export const save_SubscriptionKey = (SubscriptionKey) => ({
  type: NEW_SUBSCRIPTIONKEY,
  payload: SubscriptionKey,
});

export const save_recieved_client_ID = (clientId) => ({
  type: RECEIEVD_CLIENTID,
  payload: clientId,
});

export const save_callbackUrl = (callbackUrl) => ({
  type: NEW_CALL_BACK_URL,
  payload: callbackUrl,
});

//newchanges03112025
export const generatecode_based_token = (SubscriptionKey) => {
  return async (dispatch, getState) => {
    let code = getState().common.code;
    let clientId = getState().common.rclientId;
    let new_call_back_url = getState().common.new_call_back_url;
    const headers = {
      "Content-Type": "application/json",
      clientId: clientId,
      SubscriptionKey: SubscriptionKey,
    };
    try {
      const response = await axios.get(`${codetoken}/getToken?code=${code}`, {
        headers,
      });

      const { access_token } = response.data;

      if (access_token) {
        dispatch({
          type: SAVE_AUTH_TOKEN,
          access_token: access_token,
        });
      }

      // Show the popup or take further action with the response
      //alert("API Call Successful. Data: " + JSON.stringify(datafromDecryptApi));
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMsg =
          error.response.data?.errorMsg ||
          error.response.data?.message ||
          "Authorization code is invalid or expired";
        // alert(errorMsg);
        // location.href = new_call_back_url;
        return Promise.reject(new Error(errorMsg));
      } else {
        // Reject with a generic error if the error doesn't match the expected one
        return Promise.reject(
          new Error("Something Went Wrong..please Try again"),
        );
      }
    }
  };
};

export const callEncryptionAPI = (
  consentGroupId,
  clientId,
  txnId,
  mob,
  consentCreateTimestamp,
  timestamp,
  accessToken,
) => {
  return async (dispatch, getState) => {
    let headers = {
      "Content-Type": "application/json",
      //Authorization: `Basic ${accessToken}`,
      clientId: clientId,
      txnId: txnId,
    };

    let requestBody = {
      clientId: clientId,
      consentGroupId: consentGroupId,
      txnId: txnId,
      customerId: mob,
      consentCreateTimestamp: consentCreateTimestamp,
      timestamp: timestamp,
    };

    try {
      let response = await axios.post(config.ENCRYPTAPI, requestBody, {
        headers,
      });
      let encryptedData = response.data.encryptedData;

      dispatch({
        type: ENCRYPTAPISUCCCESS,
        clientId: clientId,
        encryptedData: encryptedData,
      });

      return encryptedData; // Return the encrypted data
    } catch (e) {
      console.error("Error in callEncryptionAPI: ", e);
    }
  };
};

export const callRedirectAPI = (
  encryptedData,
  clientIDrecieved,
  callbackUrl,
) => {
  return async (dispatch, getState) => {
    //alert("hjojbj")
    const accessToken = getState().common.access_token;
    const subscriptionKey = getState().common.subscriptionKey; // Get the token from cookies
    //const clientId = getState().common.clientId; // Access clientId from the Redux state
    //alert("clientId in callRedirectAPI->" +clientIdcallRedirectAPI);

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`, // Uncomment if authorization is required
      clientId: clientIDrecieved,
      callback: callbackUrl, // Replace with actual callback URL
      SubscriptionKey: subscriptionKey,
    };

    try {
      // Call the GET API with encryptedData appended to the URL
      const response = await axios.get(
        `${encryptedData_Redirect_Portal}/getConsentPopupData?encryptedData=${encryptedData}`,
        { headers },
      );

      const datafromDecryptApi = response.data; // Extract data from the response
      // Extract the "data" field
      const { data } = datafromDecryptApi.consentNotice || {};
      const {
        consentGroupName,
        templates,
        logo,
        consentText,
        referenceId,
        appName,
        theme,
      } = datafromDecryptApi;
      //alert("templates in common action->" + JSON.stringify(templates));
      // Dispatch the response data to the Redux store
      dispatch({
        type: DECRYPTAPISUCCESS,
        datafromDecryptApi, // Save the entire response data
        consentGroupName,
        templates,
        logo,
        consentText,
        referenceId,
        appName,
        theme,
        data,
      });

      // Show the popup or take further action with the response
      //alert("API Call Successful. Data: " + JSON.stringify(datafromDecryptApi));
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMsg = error.response.data?.errorMsg;

        // alert(errorMsg);
        // location.href = new_call_back_url;
        return Promise.reject(new Error(errorMsg));
      } else {
        // Reject with a generic error if the error doesn't match the expected one
        return Promise.reject(
          new Error("Something Went Wrong..please Try again"),
        );
      }
    }
  };
};

export const createConsentAPI = () => {
  return async (dispatch, getState) => {
    let headers = {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${accessToken}`,
      clientId: clientId, // Use the token from cookies
    };
    let createConsentBody = {
      referenceId: referenceId,
      templateId: ["7311f867-00a9-4a0a-a67e-1e5fba20c982"],
    };

    try {
      let createConsentResponse = await makeAPICall(
        config.CREATCONSENT,
        "POST",
        createConsentBody,
        headers,
      );
      let clientId = createConsentResponse.data.clientId;
      //alert('Token resp CHECKING->'+JSON.stringify(access_token));
      dispatch({
        type: CREATCONSENTSUCCESS,
        consentId: consentId,
        callback: callback,
        timestamp: timestamp,
        txnid: txnid,
      });
    } catch (e) {
      // alert('TOKEN----->'+JSON.stringify(access_token));
    }
  };
};

export const GetTempDetail = (tempId, customerId, clientId) => {
  return async (dispatch, getState) => {
    let access_token = getState().common.access_token;

    // alert("tempId : "+tempId);

    const tempIdArray = tempId.split(",");

    var headers = {
      // "clientId":clientId,
      // "Authorization":`Bearer ${access_token}`
    };
    var request = {
      consenttemplates: tempIdArray,
    };
    try {
      let resp = await makeAPICall(
        config.GetMultipleTemplatesByTemplateIds,
        "POST",
        request,
        headers,
      );
      let data = resp.data;
      // let clientId = data.clientId

      dispatch({
        type: GET_TEMP_DETAILS,
        data,
        tempId,
        clientId,
        customerId,
      });
    } catch (error) {}
  };
};

export const getTemplateDetailByConsentGroupId = (consentGroupId) => {
  return async (dispatch, getState) => {
    //alert("in getTemplateDetailByConsentGroupId "+consentGroupId);
    let access_token = getState().common.access_token;

    var headers = {
      // "clientId":clientId,
      // "Authorization":`Bearer ${access_token}`
      //"Ocp-Apim-Subscription-Key":"67f3ffc1caa7452580cacad971ff3bf7"
    };
    try {
      // let resp = await makeAPICall(config.GET_CONSENTGROUPID+`/${consentGroupId}`, "GET", {}, headers);
      // //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
      // let data = resp.data

      let respTemp = await makeAPICall(
        config.GET_TEMPLATE_BY_CONSENT_GROUPID + `/${consentGroupId}`,
        "GET",
        {},
        headers,
      );
      //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
      let templates = respTemp.data;
      //data.templateIds=templates

      //alert('value of getConsentGroupDataByGroupId in commonaction '+JSON.stringify(data))
      // alert(`Response getConsentGroupDataByGroupId---------------------> ${JSON.stringify(data)}`);
      // alert('data ' +  JSON.stringify(data))

      dispatch({
        type: GET_CONSENTGROUPDATABY_GROUPID,
        templates,
      });
    } catch (error) {}
  };
};

// export const getPreferenceCenterThemeByClient = (clientId) =>{

//     return async (dispatch,getState)=>{

//        // alert("in getPreferenceCenterThemeByClient");
//         let access_token = getState().common.access_token;

//         var headers = {
//             // "clientId":clientId,
//             // "Authorization":`Bearer ${access_token}`
//         }
//         try {
//             let resp = await makeAPICall(config.getPreferenceCenterThemeByClient, "GET", {}, headers);
//             //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
//             let data = resp.data

//            // alert('data ' +  JSON.stringify(data))

//             dispatch({
//                 type:GET_PREFERENCE_CENTER_THEME,
//                 data
//             })
//         } catch (error) {
//         }

//     }

// }

export const getPreferenceCenterThemeByGroupId = (consentGroupId) => {
  return async (dispatch, getState) => {
    // alert("in getPreferenceCenterThemeByClient");
    let access_token = getState().common.access_token;

    var headers = {
      // "clientId":clientId,
      // "Authorization":`Bearer ${access_token}`
    };
    try {
      let resp = await makeAPICall(
        config.getPreferenceCenterThemeByGroupId + `/${consentGroupId}`,
        "GET",
        {},
        headers,
      );
      //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
      let data = resp.data;

      // alert('data ' +  JSON.stringify(data))

      dispatch({
        type: GET_PREFERENCE_CENTER_THEME,
        data,
      });
    } catch (error) {}
  };
};

export const getConsentTextByGroupID = (consentGroupId) => {
  return async (dispatch, getState) => {
    // alert("in getPreferenceCenterThemeByClient");
    let access_token = getState().common.access_token;

    var headers = {
      // "clientId":clientId,
      // "Authorization":`Bearer ${access_token}`
    };
    try {
      let resp = await makeAPICall(
        config.GET_CONSENTGROUPID + `/${consentGroupId}`,
        "GET",
        {},
        headers,
      );
      //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
      let data = resp.data.consentText;

      //alert('data ' +  JSON.stringify(data))

      dispatch({
        type: GET_CONSENT_TEXT,
        data,
      });
    } catch (error) {}
  };
};

// export const CreateConsent = (templateIdArray, referenceId, clientIDrecieved)=>{
//     //alert("clientIDrecieved->" + clientIDrecieved);
//     //alert('INSIDE Create Consent-->')
//     return async (dispatch,getState)=>{
//         let customerId = getState().common.customerId;
//         //let templateId = getState().common.templateId;
//         let clientId = getState().common.clientId;
//         let clientSecret = getState().common.clientSecret;
//         // let tempIdArray = [];

//      //   alert("consent check in CreateConsent "+consentCheck);

//         let access_token = getState().common.access_token;
//         //alert("Access Token in CreateConsent "+access_token);
//         // if(consentCheck){
//         //     //alert("in true")
//         //     tempIdArray = templateId.split(",");
//         //     //alert("create consent tempIdArray : "+tempIdArray);
//         // }else{
//         //     //alert("in false")
//         //     tempIdArray = templateId.split(",")[0];
//         //    // alert("create consent tempIdArray : "+tempIdArray);
//         // }

//         //alert("create consent tempIdArray : "+tempIdArray);

//         var headers = {
//             clientId: clientIDrecieved,
//             // "Authorization":`Bearer ${access_token}`,
//             // "clientId" : clientIDrecieved,
//             // "clientSecret":clientSecret,
//         }
//         // var req = {
//         //     "referenceId": referenceId,
//         //     "consentDetail": {
//         //         "consentStart": start,
//         //         "customer": {
//         //             "referenceId": referenceId,
//         //             "consentTemplateID": templateIdArray
//         //         }
//         //     }
//         // }

//         var req = {
//             "referenceId": referenceId,
//             "templateIds": templateIdArray
//         };

//         try {
//             //alert("headers->" + JSON.stringify(headers));
//             let resp = await APICall(config.CreateConsent, "POST", req, headers);
//             let responseFromCreateConsent = resp.data
//             //alert("response-->" + responseFromCreateConsent.callback);
//             dispatch({
//                 type:CALL_BACK_URL,
//                 responseFromCreateConsent
//             })
//         } catch (error) {
//         }

//     }
// }

export const CreateConsent = (
  templateIdArray,
  referenceId,
  clientIDrecieved,
) => {
  return async (dispatch, getState) => {
    let customerId = getState().common.customerId;
    let clientId = getState().common.clientId;
    let clientSecret = getState().common.clientSecret;
    let access_token = getState().common.access_token;
    const subscriptionKey = getState().common.subscriptionKey;

    var headers = {
      clientId: clientIDrecieved,
      //SubscriptionKey: "41421489a325462ba7d301e613603281",
      SubscriptionKey: subscriptionKey,
    };

    var req = {
      referenceId: referenceId,
      templateIds: templateIdArray,
    };

    try {
      let resp = await APICall(config.CreateConsent, "POST", req, headers);

      // If the response indicates success, proceed
      if (resp.status === 200) {
        let responseFromCreateConsent = resp.data;
        dispatch({
          type: CALL_BACK_URL,
          responseFromCreateConsent,
        });
      } else {
        // If the response is not successful, throw an error
        throw new Error(`Failed to create consent: ${resp.statusText}`);
      }
    } catch (error) {
      console.error("Error during CreateConsent:", error);
      throw error; // Re-throw the error to be caught in the calling function
    }
  };
};

export const consentByCustomerId = () => {
  //alert('Inside API call ')
  return async (dispatch, getState) => {
    let ActiveList = [];
    let RevokeList = [];
    let AllConsent = [];

    let customerId = getState().common.customerId;
    let clientId = getState().common.clientId;
    let clientSecret = getState().common.clientSecret;

    let access_token = getState().common.access_token;

    var headers = {
      "Content-Type": "application/json",
      clientId: clientId,
      clientSecret: clientSecret,
      txnId: "92929bc1-a28f-5d68-91af-44",
      Authorization: `Bearer ${access_token}`,
      SubscriptionKey: process.env.REACT_APP_SUBSCRIPTION_KEY,
    };

    let resp = await makeAPICall(
      config.GetConsentDetailsByCustomerId + `/${customerId}`,
      "GET",
      null,
      headers,
    );
    let list = resp.data;
    list.map((item, key) => {
      if (item.status == "ACTIVE") {
        ActiveList.push(item);
        AllConsent.unshift(item);
        // ActiveList.unshift(item)
      }
    });

    let respRevoked = await makeAPICall(
      config.GetRevokedConsentDetailConsentId + `/${customerId}`,
      "GET",
      null,
      headers,
    );
    //alert('value of consentByCustomerId respRevoked ' + JSON.stringify(respRevoked))
    let revokedList = respRevoked.data;

    revokedList.map((item, key) => {
      RevokeList.push(item);
      AllConsent.unshift(item);
    });

    dispatch({
      type: CONSENT_HISTORY,
      ActiveList,
      RevokeList,
      AllConsent,
    });
  };
};

export const consentBytxnId = () => {
  return async (dispatch, getState) => {
    let ActiveList = [];
    let RevokeList = [];
    let AllConsent = [];

    let customerId = getState().common.customerId;
    let clientId = getState().common.clientId;
    let clientSecret = getState().common.clientSecret;

    let access_token = getState().common.access_token;

    var headers = {
      "Content-Type": "application/json",
      clientId: clientId,
      clientSecret: clientSecret,
      txnId: "92929bc1-a28f-5d68-91af-44",
      Authorization: `Bearer ${access_token}`,
      SubscriptionKey: process.env.REACT_APP_SUBSCRIPTION_KEY,
    };

    let resp = await makeAPICall(
      config.GetConsentDetailsByTxnId + `/${txnId}`,
      "GET",
      null,
      headers,
    );
    let list = resp.data;
    list.map((item, key) => {
      if (item.status == "ACTIVE") {
        ActiveList.push(item);
        AllConsent.unshift(item);
        // ActiveList.unshift(item)
      }
    });

    let respRevoked = await makeAPICall(
      config.GetConsentDetailsByTxnId + `/${txnId}`,
      "GET",
      null,
      headers,
    );
    //alert('value of consentByCustomerId respRevoked ' + JSON.stringify(respRevoked))
    let revokedList = respRevoked.data;

    revokedList.map((item, key) => {
      if (item.status == "INACTIVE") {
        RevokeList.push(item);
        AllConsent.unshift(item);
      }
    });

    dispatch({
      type: CONSENT_HISTORY,
      ActiveList,
      RevokeList,
      AllConsent,
    });
  };
};

export const getProfileData = (clientId) => {
  //alert("client Id is called "+clientId);

  return async (dispatch, getState) => {
    const access_token = getState().common.access_token;
    //  let clientId = getState().common.clientId;
    //  let clientSecret = getState().common.clientSecret;
    //  let access_token = getState().common.access_token;

    let headers = {
      // "clientId" : clientId,
      // "clientSecret":clientSecret,
      // "Authorization":`Bearer ${access_token}`
    };

    let resp = await makeAPICall(
      config.GET_PROFILE_DATA + `/${clientId}`,
      "GET",
      {},
      headers,
    );
    let profileData = resp.data;

    const App_Name = profileData.appName;
    const App_Logo = profileData.logo;

    // let logoBase64 = resp.data.logo;

    // base64ToImage(logoBase64)
    //     .then((image) => {
    //     })
    //     .catch((error) => {
    //         // An error occurred while loading the image
    //         console.error(error);
    //     });

    dispatch({
      type: PROFILE_DATA,
      profileData,
    });
    dispatch({
      type: APP_NAME,
      App_Name,
    });
    dispatch({
      type: APP_LOGO,
      App_Logo,
    });
  };
};

export const saveParamsToState = (
  customerId,
  clientId,
  clientSecret,
  consentGroupId,
  callbackURL,
) => {
  return async (dispatch, getState) => {
    dispatch({
      type: paramsFromState,
      customerId,
      clientId,
      clientSecret,
      consentGroupId,
      callbackURL,
    });
  };
};

export const saveParamsToStateHistory = (
  customerId,
  clientId,
  clientSecret,
) => {
  return async (dispatch, getState) => {
    dispatch({
      type: paramsFromStateHistory,
      customerId,
      clientId,
      clientSecret,
    });
  };
};
